import { HpcsCode } from "../../../../data-model/medicalPaOrdersModel";
import { MedicalPaOrdersAuthStatus } from "../../../../enums/medicalPaOrdersAuthStatus";

export const mergedHpcsCodeWithUniqueJcode = (
  allOldHpcsCodes: HpcsCode[],
  newHpCsCodeWithAuthStatus: HpcsCode[],
) => {
  return Array.from(
    new Map(
      [...allOldHpcsCodes, ...newHpCsCodeWithAuthStatus].map((h) => [
        h.j_code ?? "",
        {
          ...h,
          auth_status: h.auth_status ?? MedicalPaOrdersAuthStatus.AuthRequired,
        },
      ]),
    ).values(),
  ) as HpcsCode[];
};
